{
  "name": "alive-angular",
  "version": "3.4.11",
  "scripts": {
    "cy": "cypress open",
    "ng": "ng",
    "start": "npm run deployFixes && ng serve --port=4567 --host=0.0.0.0",
    "start:fr": "npm run deployFixes && ng serve --port=4567 --host=0.0.0.0 --configuration=fr",
    "deployFixes": "node deployFixes.js",
    "b": "npm run buildprod",
    "bd": "npm run buildprod && npm run deployprod",
    "build": "npm run deployFixes && ng build",
    "buildprod": "rm -r ./dist && npm run deployFixes && npm run generate:sitemaps && npm run generate:robots && npx createAngularStaticHashes --staticAssetsPath=src/assets --globPattern=/**/config.json && npm run buildprod_en && npm run buildprod_fr && npm run buildprod_es",
    "deployprod": "npm run sentry:sourcemaps && npm run sentry:sourcemaps:remove && node deployNonIndexFiles.js",
    "deployprodindex": "node deployIndexFiles.js && node --env-file=.env appUpdate.js",
    "bdtest": "npm run buildTest && npm run deployTest",
    "buildTest": "rm -r ./dist && npm run deployFixes && npm run generate:sitemaps && npm run generate:robots && npx createAngularStaticHashes --staticAssetsPath=src/assets --globPattern=/**/config.json && npm run buildtest_en && npm run buildtest_fr && npm run buildtest_es",
    "deployTest": "node deployTestFiles.js",
    "buildprod_en": "ng build -c=production --deploy-url https://livestatic.athletic.net/ && node_modules/.bin/gulp b --locale en",
    "buildprod_fr": "ng build -c=production,fr --deploy-url https://livestatic.athletic.net/fr/ && node_modules/.bin/gulp b --locale fr",
    "buildprod_es": "ng build -c=production,es --deploy-url https://livestatic.athletic.net/es/ && node_modules/.bin/gulp b --locale es",
    "buildtest_en": "ng build -c=production && node_modules/.bin/gulp b --locale en",
    "buildtest_fr": "ng build -c=production,fr && node_modules/.bin/gulp b --locale fr",
    "buildtest_es": "ng build -c=production,es && node_modules/.bin/gulp b --locale es",
    "generate:sitemaps": "node generateSiteMaps.js",
    "generate:robots": "node generateRobotsTxt.js",
    "extracti18n": "ng extract-i18n --out-file src/locale/messages.xlf && npx prettier src/locale/messages.xlf --write --plugin=@prettier/plugin-xml",
    "sentry:sourcemaps": "sentry-cli releases new --org spikefalcon --project athletic-live-angular $npm_package_version && sentry-cli sourcemaps inject --release=$npm_package_version --org spikefalcon --project athletic-live-angular ./dist/alive-angular/browser && sentry-cli sourcemaps upload --release=$npm_package_version --org spikefalcon --project athletic-live-angular ./dist/alive-angular/browser",
    "sentry:sourcemaps:remove": "rm -r dist/alive-angular/browser/*.map",
    "watch": "npm run deployFixes && ng build --watch --configuration development",
    "test": "npm run deployFixes && ng test",
    "format": "prettier --write '**/?(.)*.{css,scss,js,ts,tsx,json,yaml,yml,html}'",
    "lint:format": "prettier --check '**/?(.)*.{css,scss,js,ts,tsx,json,yaml,yml,html}'",
    "prepare": "husky",
    "---unused/deprecated commands below---": "",
    "buildProdSingleSite": "npm run deployFixes && npx createAngularStaticHashes --staticAssetsPath=src/assets --globPattern=/**/config.json && ng build -c=production && node_modules/.bin/gulp b",
    "deployProdSingleSite": "npm run sentry:sourcemaps && npm run sentry:sourcemaps:remove && rsync --exclude=\"{'index.html'}\" -a dist/alive-angular/browser/ admin@web21:/srv/www/trackmeet.io/htdocs/dist_new_qld && rsync --exclude=\"{'index.html'}\" -a dist/alive-angular/browser/ admin@107.170.36.19:/srv/www/trackmeet.io/htdocs/dist_new_qld && rsync --exclude=\"{'index.html'}\" -a dist/alive-angular/browser/ admin@192.241.173.6:/srv/www/trackmeet.io/htdocs/dist_new_qld",
    "deployProdSingleSiteIndex": "rsync dist/alive-angular/browser/index.html admin@web21:/srv/www/trackmeet.io/htdocs/dist_new_qld/index.html && rsync dist/alive-angular/browser/index.html admin@107.170.36.19:/srv/www/trackmeet.io/htdocs/dist_new_qld/index.html && rsync dist/alive-angular/browser/index.html admin@192.241.173.6:/srv/www/trackmeet.io/htdocs/dist_new_qld/index.html",
    "serve:ssr:alive-angular": "node dist/alive-angular/server/server.mjs",
    "mtr": "git checkout master && git pull origin master && git checkout release && git merge master"
  },
  "engines": {
    "node": "22.x"
  },
  "private": true,
  "dependencies": {
    "18": "^0.0.0",
    "@angular/animations": "^20.3.9",
    "@angular/cdk": "^20.2.11",
    "@angular/common": "^20.3.9",
    "@angular/compiler": "^20.3.9",
    "@angular/core": "^20.3.9",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "^20.3.9",
    "@angular/platform-browser": "^20.3.9",
    "@angular/platform-browser-dynamic": "^20.3.9",
    "@angular/platform-server": "^20.3.9",
    "@angular/router": "^20.3.9",
    "@angular/ssr": "^20.1.1",
    "@athleticnet/athletic-live-api": "20.0.39",
    "@athleticnet/athletic-live-api-models": "3.0.35",
    "@brightcove/player-loader": "^1.8.0",
    "@fortawesome/angular-fontawesome": "^2.0.1",
    "@fortawesome/fontawesome-svg-core": "^6.5.1",
    "@fortawesome/free-brands-svg-icons": "^6.5.1",
    "@fortawesome/pro-duotone-svg-icons": "^6.5.1",
    "@fortawesome/pro-light-svg-icons": "^6.5.1",
    "@fortawesome/pro-regular-svg-icons": "^6.5.1",
    "@fortawesome/pro-solid-svg-icons": "^6.5.1",
    "@fortawesome/sharp-regular-svg-icons": "^6.5.1",
    "@fortawesome/sharp-solid-svg-icons": "^6.5.1",
    "@ng-bootstrap/ng-bootstrap": "^19.0.1",
    "@ng-select/ng-select": "^15.1.3",
    "@popperjs/core": "^2.11.8",
    "@sentry/angular": "^9.40.0",
    "@sitelintcode/angular-static-assets-hash": "^0.0.21",
    "@types/video.js": "^7.3.46",
    "bootstrap": "^5.3.8",
    "express": "^4.18.2",
    "jwt-decode": "^4.0.0",
    "luxon": "^3.4.3",
    "minimist": "^1.2.8",
    "ngx-cookie-service": "^20.0.1",
    "ngx-countdown": "^16.0.0",
    "rxjs": "~7.8.0",
    "swiper": "^10.3.1",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.1.1",
    "@angular/cli": "~20.3.8",
    "@angular/compiler-cli": "^20.3.9",
    "@angular/localize": "^20.3.9",
    "@prettier/plugin-xml": "^3.4.1",
    "@sentry/cli": "^2.33.1",
    "@types/express": "^4.17.17",
    "@types/jasmine": "~4.3.0",
    "@types/luxon": "^3.3.2",
    "@types/node": "^22.0.0",
    "browser-sync": "^3.0.0",
    "cypress": "^12.16.0",
    "gulp": "^4.0.2",
    "gulp-inject": "^5.0.5",
    "gulp-inject-string": "^1.1.2",
    "gulp-replace": "^1.1.4",
    "husky": "^9.0.11",
    "jasmine-core": "~4.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^15.2.2",
    "prettier": "^3.3.3",
    "replace-in-file": "^7.1.0",
    "source-map-explorer": "^2.5.3",
    "typescript": "~5.8.3"
  },
  "lint-staged": {
    "*.{css,scss,js,ts,tsx,json,yaml,yml,html}": "prettier --write"
  }
}
